import React, { Component } from 'react';
import { CheckBox } from '../common/forms';
import { LabelWithArrow, Load } from '../common/basic';
import ReactDom from 'react-dom';
import axios from 'axios';
import { Radio } from 'react-bootstrap';
import dateHelper from '../../helpers/date';
import ReactModal from 'react-modal';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';

let tmpVal = [];
let open = '';
module.exports = class ScheduleChooseDatesContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            RepeatDates: this.props.RepeatDates,
            RepeatDay: this.props.RepeatDay,
            RepeatType: this.props.RepeatType,
            showModal: false,
            enableSaveBtn: false
        }

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.getValue = this.getValue.bind(this);
        this.updateSaveBtnState = this.updateSaveBtnState.bind(this);


        this.updateSaveBtnState();
    }

    handleOpenModal() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    handleSave() {
        if (open == 'days')
            this.setState({ RepeatDay: tmpVal });
        else
            this.setState({ RepeatDates: tmpVal });

        this.props.onChange(tmpVal);
        this.handleCloseModal();
    }

    changeSelectedType(RepeatType, e) {
        this.setState({
            RepeatType: RepeatType
        })
    }

    onChangeDays(RepeatVal) {
        tmpVal = RepeatVal;
        this.updateSaveBtnState();
    }

    onChangeDates(dates) {
        tmpVal = dates;
        this.updateSaveBtnState();
    }

    updateSaveBtnState() {
        if (this.state.RepeatType == "WEEKLY" && ["1", "2", "3", "4", "5", "6", "7"].includes(tmpVal)) {
            this.setState({ enableSaveBtn: true });
        } else if (this.state.RepeatType == "BIWEEKLY" && Array.isArray(tmpVal) && tmpVal.length == 2) {
            this.setState({ enableSaveBtn: true });
        } else if (this.state.RepeatType == "MONTHLY" && Array.isArray(tmpVal) && tmpVal.length == 1) {
            this.setState({ enableSaveBtn: true });
        } else if (this.state.RepeatType == "FREE" && Array.isArray(tmpVal) && tmpVal.length > 0) {
            this.setState({ enableSaveBtn: true });
        } else {
            this.setState({ enableSaveBtn: false });
        }
    } 

    ArrayFromStrToDates(RepeatDates) {
        var dates = [];
        if (RepeatDates) {
            for (var i = 0; i < RepeatDates.length; i++) {
                if (dateHelper.validateDateFromClient(RepeatDates[i])) {
                    dates.push(dateHelper.fromStrToDate(RepeatDates[i]));
                }
                else {
                    dates.push(new Date(RepeatDates[i]));
                }
            }
        }
        return dates;
    }

    getValue() {
        if (open == 'days')
            return this.state.RepeatDay;

        return this.ArrayFromStrToDates(this.state.RepeatDates);
    }

    render() {
        var repeatDays = "";
        if (this.state.RepeatDay) {
            if (this.state.RepeatType == "WEEKLY") {
                repeatDays = "Every " + dateHelper.fromNumberToWeekDay(this.state.RepeatDay[0]);
            }
            else if (this.state.RepeatType == "BIWEEKLY") {
                repeatDays = dateHelper.fromNumberToWeekDay(this.state.RepeatDay[0]) + " & " + dateHelper.fromNumberToWeekDay(this.state.RepeatDay[1]);
            }
            else if (this.state.RepeatType == "MONTHLY") {
                repeatDays = "Every " + this.state.RepeatDay[0] + "th";
            }
        }

        var classes = "chooseDates " + this.props.className;

        var contentObject;
        var title;
        if (this.state.RepeatType == "WEEKLY") {
            title = "Choose day";
            open = 'days';
            contentObject = <ChooseWeekly onChange={this.onChangeDays.bind(this)} value={this.state.repeatDay} getValue={this.getValue} />;
        }
        else if (this.state.RepeatType == "BIWEEKLY") {
            title = "Choose days";
            open = 'days';
            contentObject = <ChooseBiWeekly onChange={this.onChangeDays.bind(this)} value={this.state.repeatDay} getValue={this.getValue} />;
        }
        else if (this.state.RepeatType == "MONTHLY") {
            title = "Choose day";
            open = 'days';
            contentObject = <ChooseMonthly onChange={this.onChangeDays.bind(this)} value={this.state.repeatDay} getValue={this.getValue} />;
        }
        else if (this.state.RepeatType == "FREE") {
            title = "Choose dates";
            open = 'dates';
            contentObject = <ChooseFree onChange={this.onChangeDates.bind(this)} getValue={this.getValue} />
        }

        return (
            <div className={classes}>

                <ReactModal
                    isOpen={this.state.showModal}
                    contentLabel="onRequestClose Example"
                    onRequestClose={this.handleCloseModal}
                    className="Modal-Popup"
                    overlayClassName="Modal-Overlay">
                    <h3>{title}</h3>
                    {contentObject}

                    <button onClick={this.handleSave} disabled={!this.state.enableSaveBtn}>Done</button> <button onClick={this.handleCloseModal}>Cancel</button>
                </ReactModal>
                <div className='days'>{repeatDays}</div>
                <div className='edit' onClick={this.handleOpenModal}>Edit</div>
            </div>
        )
    }
}

class ChooseWeekly extends React.Component {
    constructor(props) {
        super(props);

        var value = this.props.getValue()[0];
        this.state = { value: value };

        this.changeDay = this.changeDay.bind(this);
    }

    changeDay(e) {
        var val = e.target.value;
        this.setState({ value: val });
        this.props.onChange(val);
    }

    render() {
        return (
            <div className='ChooseWeekly'>
                <RadioCircle value={1} onChange={this.changeDay} text="S" checked={this.state.value == 1 ? true : false} />
                <RadioCircle value={2} onChange={this.changeDay} text="M" checked={this.state.value == 2 ? true : false} />
                <RadioCircle value={3} onChange={this.changeDay} text="T" checked={this.state.value == 3 ? true : false} />
                <RadioCircle value={4} onChange={this.changeDay} text="W" checked={this.state.value == 4 ? true : false} />
                <RadioCircle value={5} onChange={this.changeDay} text="T" checked={this.state.value == 5 ? true : false} />
                <RadioCircle value={6} onChange={this.changeDay} text="F" checked={this.state.value == 6 ? true : false} />
                <RadioCircle value={7} onChange={this.changeDay} text="S" checked={this.state.value == 7 ? true : false} />
            </div>
        )
    }
}

class RadioCircle extends React.Component {
    render() {
        return (
            <label className="roundRadio">
                <input type="checkbox" name="day" id="day" value={this.props.value} onChange={this.props.onChange} checked={this.props.checked} />
                <div>{this.props.text}</div>
            </label>
        )
    }
}


class ChooseBiWeekly extends React.Component {
    constructor(props) {
        super(props);

        var value = this.props.getValue();
        if (value && value.length == 2) {
            this.state = {
                day1: value[0],
                day2: value[1]
            }
        }
        else {
            this.state = {
                day1: '',
                day2: ''
            }
        }

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        var returnVal;
        var val = parseInt(e.target.value);
        if (e.target.checked == true) {
            if (this.state.day1 == '') {
                this.setState({ day1: val });
                returnVal = [val, this.state.day2];
            }
            else {
                this.setState({ day2: val });
                returnVal = [this.state.day1, val];
            }
        }
        else {
            if (this.state.day1 == val) {
                this.setState({ day1: '' });
                returnVal = ['', this.state.day2];
            }
            else {
                this.setState({ day2: '' });
                returnVal = [this.state.day1, ''];
            }
        }

        var result = [];
        returnVal.forEach(element => {
            if(element && element != '') {
                result.push(element);
            }
        });

        this.props.onChange(result);
    }

    render() {
        return (
            <div className='ChooseWeekly'>
                <RadioCircle value='1' onChange={this.onChange} text="S" checked={(this.state.day1 == 1 || this.state.day2 == 1)} />
                <RadioCircle value='2' onChange={this.onChange} text="M" checked={(this.state.day1 == 2 || this.state.day2 == 2)} />
                <RadioCircle value='3' onChange={this.onChange} text="T" checked={(this.state.day1 == 3 || this.state.day2 == 3)} />
                <RadioCircle value='4' onChange={this.onChange} text="W" checked={(this.state.day1 == 4 || this.state.day2 == 4)} />
                <RadioCircle value='5' onChange={this.onChange} text="T" checked={(this.state.day1 == 5 || this.state.day2 == 5)} />
                <RadioCircle value='6' onChange={this.onChange} text="F" checked={(this.state.day1 == 6 || this.state.day2 == 6)} />
                <RadioCircle value='7' onChange={this.onChange} text="S" checked={(this.state.day1 == 7 || this.state.day2 == 7)} />
            </div>
        )
    }
}


class ChooseMonthly extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        var value = this.props.getValue()[0];
        this.state = { value: value };
    }

    onChange(val) {
        this.setState({ value: val });
        this.props.onChange([val]);
    }

    render() {
        // Every <DropDown Data={items} Label="Choose Day" onChange={this.onChange} addLabelWhenChosen='th' value={this.state.value} />
        return (
            <div className='ChooseWeekly'>
                <div className="DayPicker-Body" role="rowgroup">
                    <WeekClass start={1} end={7} onChange={this.onChange} checked={this.state.value} />
                    <WeekClass start={8} end={14} onChange={this.onChange} checked={this.state.value} />
                    <WeekClass start={15} end={21} onChange={this.onChange} checked={this.state.value} />
                    <WeekClass start={22} end={28} onChange={this.onChange} checked={this.state.value} />
                    <WeekClass start={29} end={31} onChange={this.onChange} checked={this.state.value} />
                </div>
            </div>
        )
    }
}

class WeekClass extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(val) {
        this.props.onChange(val);
    }

    render() {
        var allObjs = [];
        for (var i = this.props.start; i <= this.props.end; i++) {
            if (this.props.checked == i) {
                allObjs.push(<DayClass val={i} onChange={this.onChange} checked={true} />);
            }
            else {
                allObjs.push(<DayClass val={i} onChange={this.onChange} />);
            }
        }

        return (
            <div className="DayPicker-Week" role="row">
                {allObjs}
            </div>
        )
    }
}

class DayClass extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange() {
        this.props.onChange(this.props.val);
    }

    render() {
        var className = "DayPicker-Day";
        if (this.props.checked)
            className += " DayPicker-Day--selected";
        return (
            <div className={className} role="gridcell" aria-disabled="false" aria-selected="false" onClick={this.onChange}>{this.props.val}</div>
        )
    }
}


class ChooseFree extends React.Component {
    constructor(props) {
        super(props);

        var value = this.props.getValue();
        if (value)
            this.state = { selectedDays: value.slice() };
        else
            this.state = { selectedDays: [] }

        this.handleDayClick = this.handleDayClick.bind(this);
    }

    handleDayClick(day) {
        const selectedDays = this.state.selectedDays;
        const selectedIndex = selectedDays.findIndex(selectedDay =>
            DateUtils.isSameDay(selectedDay, day)
        );
        if (selectedIndex != -1) {
            selectedDays.splice(selectedIndex, 1);
        } else {
            selectedDays.push(day);
        }
        this.setState({ selectedDays: selectedDays });
        this.props.onChange(selectedDays);
    }

    render() {
        var dates = '';
        if (this.state.selectedDays.length > 0) {
            dates = 'Dates: ';
            for (var i = 0; i < this.state.selectedDays.length; i++) {
                if (i > 0) {
                    dates += ', ';
                }
                dates += dateHelper.fromDBStrToStr(this.state.selectedDays[i]);
            }
        }
        return (
            <div className='ChooseWeekly'>

                <DayPicker
                    selectedDays={this.state.selectedDays}
                    onDayClick={this.handleDayClick}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./modules/doctorAdvice/ScheduleChooseDatesContainer.jsx